import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyA65ZED5nALmothFhYQL-1pV9lBjvKFUwQ',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'gearcompare-49e60.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'gearcompare-49e60',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'gearcompare-49e60.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '431063877861',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:431063877861:web:ea442380672e535009ec0c'
};

// Initialize Firebase
let app;
try {
  // Only log in development mode
  if (process.env.NODE_ENV === 'development') {
    console.log('🔍 Firebase config being used:', {
      projectId: firebaseConfig.projectId,
      authDomain: firebaseConfig.authDomain,
      storageBucket: firebaseConfig.storageBucket,
      apiKey: firebaseConfig.apiKey ? '***' + firebaseConfig.apiKey.slice(-4) : 'NOT_SET'
    });
  }
  app = initializeApp(firebaseConfig);
  if (process.env.NODE_ENV === 'development') {
    console.log('✅ Firebase initialized successfully:', {
      projectId: firebaseConfig.projectId,
      authDomain: firebaseConfig.authDomain
    });
  }
} catch (error) {
  console.error('❌ Firebase initialization failed:', error);
  console.warn('Firebase not configured. Using mock configuration for development.');
}

// Initialize Firebase services
export const auth = app ? getAuth(app) : null;
export const db = app ? getFirestore(app) : null;
export const storage = app ? getStorage(app) : null;

export default app;
